import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   ADD_WAREHOUSE,
   DELETE_WAREHOUSE,
   GET_WAREHOUSE,
   UPDATE_WAREHOUSE,
   GET_ONE_WAREHOUSES,
   MULTI_DELETE_WAREHOUSE,
} from '../types';

export const getWarehouse = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/warehouse/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_WAREHOUSE,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
         toast.error(err.response.data.message);
      } else {
         toast.error('An unknown error occurred');
      }
      return null;
   }
};

export const addWarehouse = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/warehouse/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_WAREHOUSE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Customer added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data)
         if (err.response && err.response.data && err.response.data.code === 1) {
            return;
         }
      const errorMessage = err.response?.data?.errors?.[0]?.message;
      toast.error(errorMessage || 'An error occurred. Please try again.');
      // toast.error('Failed to add customer. Please try again. :', err);
      // if (err.response.data.errors[0].message) {
      //    toast.error(err.response.data.errors[0].message);
      // }
   }
};

export const updateWarehouse = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/warehouse/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_WAREHOUSE, payload: res.data.data });

         setTimeout(() => {
            toast.success('Warehouse updated successfully!');
         }, 1000);
      }
   } catch (err) {
      // toast.error('Failed to update customer. Please try again.');
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

// Delete Warehouse
export const deleteWarehouse = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/warehouse/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_WAREHOUSE, payload: { id } });
         setTimeout(() => {
            toast.success('Warehouse deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      // toast.error('Failed to delete Warehouse. Please try again.');
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const multiDeleteWarehouse = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/warehouse/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_WAREHOUSE, payload: res.data.data });

         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const getSingleWarehouse = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/warehouse/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_WAREHOUSES, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
